import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  FunctionField,
  EditButton,
  TextInput,
  BooleanInput,
  Filter,
  useTranslate,
} from "react-admin";

const JobApplicationClosureReasonFilter = (props: any) => (
  <Filter {...props}>
    <TextInput source="name" />
    <BooleanInput source="isActive" />
  </Filter>
);

export const JobApplicationClosureReasonList = () => {
  const translate = useTranslate();
  return (
    <List filters={<JobApplicationClosureReasonFilter />} sort={{ field: "order", order: "ASC" }}>
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="name" />
        <FunctionField
          source="category"
          render={(record: Record<string, unknown>) => {
            if (!record.category) return "-";
            const key = String(record.category);
            const translationKey = `resources.job-application-closure-reason.categoryChoices.${key}`;
            const translated = translate(translationKey);
            return translated !== translationKey ? translated : key;
          }}
        />
        <FunctionField
          source="phase"
          render={(record: Record<string, unknown>) => {
            if (!record.phase) return "-";
            const key = String(record.phase);
            const translationKey = `resources.job-application-closure-reason.phaseChoices.${key}`;
            const translated = translate(translationKey);
            return translated !== translationKey ? translated : key;
          }}
        />
        <BooleanField source="isActive" />
        <NumberField source="order" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
